import { AnimationOnScroll } from 'react-animation-on-scroll';
import { Container } from '../../components';
import styles from './keto-font.module.css';
import KetoPaper from './keto-paper';
import KetoTypography, { KetoTypographyVariant } from './keto-typography';

export default function KetoFont() {
  return (
    <section className={styles.font}>
      <Container>
        <AnimationOnScroll
          offset={400}
          animateOnce
          duration={1.2}
          animateIn="animate__fadeInUp"
          className={styles.font_inner}
        >
          <div className={styles.font_start}>
            <img src="/keto/font/font.svg" alt="fonts" />
          </div>
          <div className={styles.font_end}>
            <KetoTypography
              className={styles.font_title}
              tag="h2"
              variant={KetoTypographyVariant.HEADLINE_1}
            >
              About font
            </KetoTypography>
            <KetoPaper>
              <KetoTypography
                className={styles.font_text}
                tag="p"
                variant={KetoTypographyVariant.BODY_2}
              >
                The Keto Kitchen brandbook includes the only one font - Bellota,
                however, in different styles.
              </KetoTypography>
            </KetoPaper>
          </div>
        </AnimationOnScroll>
      </Container>
    </section>
  );
}
